import React from "react";
import CommandLink from '../commandLink/CommandLink'
import MenuItem from '../menuItem/MenuItem'
import './appWelcomeCss.css' ;
import Container from "react-bootstrap/Container"
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"
import { useTranslation } from 'react-i18next';
//import contentPicture from '/data/appData/appImages/contentImages/contentPicture.jpg'


function Content(){

    
    const { t } = useTranslation();
    return(

        <div className="content1Div">
            

            
                
                    <Container>
                        <Row>
                            <Col lg={7} md={6} sm={12} xs={12}>
                                <img   className="principalPicture" src={"/data/appData/appImages/contentImages/contentPicture.jpg"}  alt="kebab reims" /> 
                            </Col>
                            <Col lg={5} md={6} sm={12} xs={12} >
                            <p className="descriptionPar"><span className="alTsDEco">Al Ts Stud MOROCCO</span> {t("about1")}</p>

                                <p className="descriptionPar">{t("about2")} <span className="alTsDEco"> {t("mister")} TADLAOUI Said</span>, {t("about3")}</p>
                            </Col>
                        </Row>

                    </Container>
                
        </div>

    );
}

export default Content